import { FinancialServiceProviderAdapters } from '@seapoint/server/enums';
import { AccountView } from '../../../types/entity-types';

/**
 * Checks if an account can initiate payments based on its FSP adapter.
 * Only accounts with Modulr or Yapily adapters can initiate payments.
 *
 * @param account - The account to check for payment initiation capability
 * @returns true if the account can initiate payments (has Modulr or Yapily adapter), false otherwise
 */
export const canInitiatePayments = (account: AccountView) => {
  return (
    account.fspAdapter === FinancialServiceProviderAdapters.MODULR ||
    account.fspAdapter === FinancialServiceProviderAdapters.YAPILY
  );
};

/**
 * Checks if an account can initiate bulk payments based on its FSP adapter.
 * Only accounts with Modulr adapter can initiate bulk payments.
 *
 * @param account - The account to check for bulk payment initiation capability
 * @returns true if the account can initiate bulk payments (has Modulr adapter), false otherwise
 */
export const canInitiateBulkPayments = (account: AccountView) => {
  return account.fspAdapter === FinancialServiceProviderAdapters.MODULR;
};
